import React from "react";
import "./TopLogoBar.css";
import { Button, Link } from "@mui/material";

// Icons
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import PersonIcon from "@mui/icons-material/Person";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import MailIcon from "@mui/icons-material/Mail";

// Logo
import Logo from "../../../assets/images/logo.png";

export default function TopLogoBar() {
  return (
    <>
      {/* Top Bar */}
      <div className="topBar py-1" style={{ background: "#182B49", color: "#fff" }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="d-flex align-items-center">
                <LocationOnIcon style={{ marginRight: 5, fontSize: 18 }} />
                <small>9-5-81, Ibrahimbagh, Hyderabad - 500 031, Telangana, India</small>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 text-lg-end text-center mt-2 mt-lg-0">
              <div className="d-inline-flex align-items-center gap-2">
                <Link href="#"><FacebookIcon style={{ color: "#fff", fontSize: 20 }} /></Link>
                <Link href="#"><XIcon style={{ color: "#fff", fontSize: 20 }} /></Link>
                <Link href="#"><LinkedInIcon style={{ color: "#fff", fontSize: 20 }} /></Link>
                <Link href="#"><InstagramIcon style={{ color: "#fff", fontSize: 20 }} /></Link>
                <Button
                  variant="contained"
                  color="info"
                  size="small"
                  startIcon={<PersonIcon />}
                  style={{ textTransform: "none", fontSize: "13px" }}>
                  Parent/Student Login
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Logo & Info Section */}
      <div className="logo-section py-3">
        <div className="container">
          <div className="row align-items-center">
            {/* Logo & College Info */}
            <div className="col-lg-6 col-md-12 d-flex align-items-center mb-3 mb-lg-0">

                <div className="row">
                    <div className="col-lg-3 col-md-3 col-sm-12 text-center">
                         <div className="me-3">
                            <Link href="/">
                            <img src={Logo} alt="Logo" style={{ maxWidth: "100px" }} />
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-9 col-md-9 col-sm-12 ">
                        <div>
                            <h5 className="mb-1" style={{ color: "#182B49", fontWeight: "bold" }}>
                            Vasavi College of Engineering
                            </h5>
                            <p className="mb-0" style={{ color: "#8c0d4f", fontSize: "14px" }}>
                            Autonomous | NAAC 'A++' grade | NIRF-2024 (Band 201-300)
                            </p>
                            <p className="mb-0" style={{ color: "#023b6d", fontSize: "14px" }}>
                            All U.G. Programmes are accredited by NBA
                            </p>
                            <p className="mb-0" style={{ color: "#005751", fontSize: "14px" }}>
                            Affiliated to Osmania University | Approved by AICTE.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Contact Info */}
            <div className="col-lg-6 col-md-12 text-center d-none d-sm-none d-md-block d-lg-block" >
              <div className="row">
                <div className="col-sm-6 mb-3 mb-sm-0">
                  <Link href="mailto:principal@staff.vce.ac.in" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center">
                      <PhoneInTalkIcon style={{ fontSize: 28, color: "#182B49" }} />
                      <div className="ms-2">
                        <small>Enquiry Us</small>
                        <h6 className="mb-0">principal@staff.vce.ac.in</h6>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-sm-6">
                  <Link href="mailto:principal@staff.vce.ac.in" className="text-decoration-none text-dark">
                    <div className="d-flex align-items-center">
                      <MailIcon style={{ fontSize: 28, color: "#182B49" }} />
                      <div className="ms-2">
                        <small>Enquiry Us</small>
                        <h6 className="mb-0">principal@staff.vce.ac.in</h6>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
